<div class="cd-page">
  @if (user && user.role === 'admin') {
    <app-counselor-nav></app-counselor-nav>
  }
  @if (user && !(user.role === 'admin')) {
    <app-student-nav></app-student-nav>
  }
  <main>
    @if (career) {
      <div class="careers-page">
        <!-- BANNER -->
        <div
          class="career-hero"
          [style.backgroundImage]="'url(' + bannerUrl + ')'"
          [style.backgroundPositionY]="bannerPositionY"
        >
          <div class="hero-overlay" aria-hidden="true"></div>
          <div class="hero-content">
            <div class="hero-category" aria-live="polite" aria-atomic="true">
              {{ careerTypes.find((c) => c.id === career.career_type_id)?.name }}
            </div>
            <h1 class="hero-title">{{ career.name }}</h1>
            <p class="hero-tagline">{{ career.tagline }}</p>

            <div class="hero-stats">
              <div class="stat" [attr.aria-label]="'Average salary: ' + career.salary">
                <span class="stat-value" aria-hidden="true">{{ career.salary }}</span>
                <span class="stat-label" aria-hidden="true">Avg. Salary</span>
              </div>

              <div class="stat-divider" aria-hidden="true"></div>
              <div class="stat-divider" aria-hidden="true"></div>

              <div
                class="stat"
                [attr.aria-label]="'Required education: ' + career.required_education"
              >
                <span class="stat-value" aria-hidden="true">{{ career.required_education }}</span>
                <span class="stat-label" aria-hidden="true">Education</span>
              </div>
            </div>
          </div>
        </div>

        <div class="careers-body">
          <div class="careers-main">
            <!-- ABOUT -->
            <section class="section">
              <div class="section-label" aria-hidden="true">About this career</div>
              <h2 class="section-title">What does a {{ career.name }} do?</h2>
              <p class="section-body">{{ career.description }}</p>

              <div class="skill-tags" role="list" aria-label="Career skills">
                @for (skill of career.skills ?? []; track $index) {
                  <span class="skill-tag" role="listitem">{{ skill.value }}</span>
                }
              </div>
            </section>

            <!-- PHOTO GALLERY -->
            @if (career.CareerMedia?.length) {
              <section class="section">
                <div class="section-label" aria-hidden="true">A day in the life</div>
                <div class="photo-gallery" role="list" aria-label="Career photo gallery">
                  @for (photo of career.CareerMedia; track $index) {
                    <div class="photo-item" [class.photo-large]="$index === 0" role="listitem">
                      <img [src]="galleryUrl(photo.path)" [alt]="photo.caption" />
                      <div class="photo-caption">{{ photo.caption }}</div>
                    </div>
                  }
                </div>
              </section>
            }

            @if (career.JobListings?.length) {
              <section class="section">
                <div class="section-label" aria-hidden="true">Opportunities</div>
                <h2 class="section-title">Sample Job Listings</h2>

                <div class="job-list" role="list" aria-label="Sample job listings">
                  @for (job of career.JobListings ?? []; track job.id) {
                    <div
                      class="job-card"
                      role="listitem"
                      [attr.aria-label]="
                        job.title +
                        ' at ' +
                        job.company +
                        ', ' +
                        job.location +
                        (job.salary ? ', salary ' + job.salary : '')
                      "
                    >
                      <div class="job-card-top">
                        <div class="job-info">
                          <div class="job-title">{{ job.title }}</div>
                          <div class="job-company">{{ job.company }}</div>
                        </div>

                        <span
                          class="job-type-chip"
                          [ngClass]="job.type === 'Internship' ? 'chip-intern' : 'chip-full'"
                        >
                          {{ job.type }}
                        </span>

                        <mat-icon class="job-work-style-icon" aria-hidden="true">
                          {{
                            job.work_style === 'Remote'
                              ? 'home'
                              : job.work_style === 'Hybrid'
                                ? 'sync_alt'
                                : 'business'
                          }}
                        </mat-icon>
                      </div>

                      @if (job.description) {
                        <p class="job-description">{{ job.description }}</p>
                      }

                      <div class="job-meta">
                        <span class="job-meta-item">
                          <mat-icon class="job-meta-icon" aria-hidden="true">location_on</mat-icon>
                          {{ job.location }}
                        </span>

                        @if (job.salary) {
                          <span class="job-salary">
                            <mat-icon
                              class="job-meta-icon"
                              style="color: #00a86b"
                              aria-hidden="true"
                            >
                              payments
                            </mat-icon>
                            {{ job.salary }}
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              </section>
            }

            <!-- COUNSELOR POSTS -->
            @if (career.LinkedPosts?.length) {
              <section class="section">
                <div class="section-label" aria-hidden="true">From your counselors</div>
                <h2 class="section-title">Shared Posts</h2>

                <div class="counselor-posts" role="list" aria-label="Counselor posts">
                  @for (post of career.LinkedPosts; track post.id) {
                    <div class="counselor-post" role="listitem">
                      <div class="post-header">
                        <div class="post-avatar" aria-label="Counselor">C</div>

                        <div class="post-meta">
                          <div class="post-author">
                            {{
                              (post.User?.preferredName || post.User?.first_name) +
                                ' ' +
                                post.User?.last_name
                            }}
                          </div>
                          <div class="post-date">{{ post.createdAt | date: 'mediumDate' }}</div>
                        </div>

                        @if (post.status) {
                          <mat-chip class="post-tag">{{ post.status }}</mat-chip>
                        }
                      </div>

                      <div class="post-body" [innerHTML]="post.content"></div>
                    </div>
                  }
                </div>
              </section>
            }
          </div>

          <!-- SIDEBAR -->
          <aside class="careers-sidebar" aria-label="Related career information">
            <!-- RELATED CAREERS -->
            @if (career.RelatedCareerPages?.length) {
              <div class="sidebar-card">
                <div class="sidebar-card-title">Related careers</div>

                <div class="related-careers" role="list" aria-label="Related careers">
                  @for (related of career.RelatedCareerPages; track related.id) {
                    <a
                      class="related-career-item"
                      [routerLink]="['/counselors/careers', related.id]"
                      [attr.aria-label]="'View career page for ' + related.name"
                      role="listitem"
                    >
                      <div class="related-career-icon" aria-hidden="true">
                        {{ related.icon }}
                      </div>

                      <div class="related-career-info">
                        <div class="related-career-name">{{ related.name }}</div>
                        <div class="related-career-category">
                          {{ careerTypes.find((c) => c.id === related.career_type_id)?.name }}
                        </div>
                      </div>

                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M6 3l5 5-5 5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  }
                </div>
              </div>
            }
          </aside>
        </div>
      </div>
    }

    @if (!career) {
      <!-- LOADING STATE -->
      <div
        class="careers-loading"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-label="Loading career information"
      >
        <div class="loading-shimmer hero-shimmer" aria-hidden="true"></div>
        <div class="loading-body">
          <div class="loading-shimmer line-shimmer w60" aria-hidden="true"></div>
          <div class="loading-shimmer line-shimmer w80" aria-hidden="true"></div>
          <div class="loading-shimmer line-shimmer w40" aria-hidden="true"></div>
        </div>
      </div>
    }
  </main>
</div>
